import React, { Suspense } from "react";

const LazyPDFViewer = React.lazy(() => import("./PDFViewerInner"));

interface PDFViewerProps {
  url: string;
  /** Override the default non-fullscreen height (e.g. "h-[50vh]") */
  containerClassName?: string;
  /** Fit the complete first page between the viewer controls. */
  fitPage?: boolean;
}

const PDFViewer: React.FC<PDFViewerProps> = (props) => {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center w-full h-96 bg-gray-50 rounded-lg text-gray-500">
          Loading document…
        </div>
      }
    >
      <LazyPDFViewer {...props} />
    </Suspense>
  );
};

export default PDFViewer;
